var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAadhar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M43 40H5a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4h38a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4zM3 21h42v-4H3v4zm42-9a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3h42v-3zm0 11H3v13a2 2 0 0 0 2 2h38a2 2 0 0 0 2-2V23zm-19 6h-4a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2zm-9 0H8a1 1 0 1 1 0-2h9a1 1 0 1 1 0 2zm-9 3h6a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2z",
    fillRule: "evenodd",
    fill: "#ff7b26",
    className: "fill-000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAadhar);
export default __webpack_public_path__ + "static/media/aadhar.294683958143dd4e096c5fbf059811a0.svg";
export { ForwardRef as ReactComponent };